import React, { useContext } from 'react'
import styles from './styles.module.css'
import { Checkbox, Input, Select } from '../../../../components/ModalInputs'
import { GroupsDoVdContext } from '../../../../utils/context'

export default function Main() {
    const { formik, courses, error } = useContext(GroupsDoVdContext);

    const {
        values,
        handleChange,
        setFieldValue
    } = formik;

    return (
        <div className={styles.modalMain}>
            <div className={styles.tabWrapper}>
                <div className={styles.inputsRow}>
                    <div className={styles.inputsColumn}>
                        <Input
                            error={error('name')}
                            label='Название'
                            value={values.name || ''}
                            onChange={handleChange}
                            name='name'
                        />
                    </div>
                </div>

                <div className={styles.inputsRow}>
                    <div className={styles.inputsColumn}>
                        <Select
                            error={error('course_id')}
                            label='Дисциплина'
                            value={values.course_id || ''}
                            onChange={handleChange}
                            name='course_id'
                        >
                            <option value=''>Не выбрано</option>
                            {courses?.filter(c => c.status === 'Идет' || c.status_id === 1)
                                ?.map((el) => (
                                    <option key={el.xp_key || el.id} value={el.xp_key || el.id}>
                                        {el.name}
                                    </option>
                                ))}
                        </Select>
                    </div>
                </div>

                <div className={styles.inputsRow}>
                    <div className={styles.inputsColumn + ' ' + styles.checkbox} style={{ width: '150px' }}>
                        <Checkbox
                            label='Закрыта'
                            name='closed'
                            checked={values.closed || false}
                            onChange={(e) => setFieldValue('closed', e.target.checked)}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
